<template>
    <div class="cents">
        <van-nav-bar
        :title="$t('fkjl')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('mygd')"
            @load="onLoad"
        >
            <table border="1" frame="void"  cellspacing="0" style="width:100%;">
            <tr>
                <th>{{$t('xm')}}</th>
                <th>{{$t('sjhm')}}</th>
                <th>{{$t('lfsj')}}</th>
                <th>{{$t('shzt')}}</th>
            </tr>
            <tr v-for="(item,index) in list" :key="index">
                <td >{{item.name}}</td>
                <td>{{item.mobile}}</td>
                <td>{{ item.visit_time}}</td>
                <td>{{item.approve_state}}</td>
            </tr>
            
            </table>
        </van-list>
        <!-- <Footer :active="3" ref="footer"></Footer> -->
    </div>
</template>

<script>
import {timestampToTime} from '@/utils/index.js'
export default {
    
    data(){
        return{
            loading:false,
            finished: false,
            active:3,
            list:[],
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
            page_index:0,
            count:null,
            shzt:this.$t('wsh'),
            ysh:this.$t('ysh')
        }
    },
    mounted(){
        this.list=[]
    },
    methods:{
        goto(){
            this.$router.go(-1)
        },
        onLoad() {
            this.page_index++;
            this.getlist()
        },
        getlist(){
            let data ={
                method:'co.wx.visit.open.door.list',
                user_id:this.Userof.user_id,
                page_index:this.page_index,
                page_size:10
            }
            this.$serve(data).then(res=>{
                res.data.data.forEach(el=>{
                    el.visit_time=timestampToTime(el.visit_time*1000)
                    if(el.approve_state==0){
                        el.approve_state = this.$t('wsh')
                    }else if(el.approve_state==1){
                        el.approve_state = this.$t('ysh')
                    }
                })
                this.loading = false;
                this.count = res.data.count
                if (res.data.data == [] || this.count.length === 0) {
                    // 加载结束
                    this.finished = true;
                    return;
                }
                this.list = this.list.concat(res.data.data)
                
                if (this.list.length >= this.count) {
                    this.finished = true;
                }
            })
        }
    }
}
</script>

<style scoped>
td{border:solid #E2E2E2; border-width:0px 1px 1px 0px;}
table{border:solid #E2E2E2; border-width:1px 0px 0px 1px;}
th{
    height: 30px;
    background-color: #F2F2F2;
    font-size: 14px;
    font-weight: none
}
td{
    height: 30px;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
</style>